<template>
  <div :class="{ org: true, 'is-small': size === 'small' }" title="조직도">
    <button @click="openOrgTree" class="org-button officehome-gnb-org">
      <OrgTreeIcon />
    </button>
  </div>
</template>

<script>
import OrgTreeIcon from '@/components/Icon/management-service/OrgTreeIcon.vue';

export default {
  name: 'OrgTree',
  components: {
    OrgTreeIcon,
  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },

  methods: {
    openOrgTree() {
      const popupWidth = 1400;
      const popupHeight = 756;
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;

      // 중앙에 위치시키기 위해 좌표를 계산
      const left = screenWidth / 2 - popupWidth / 2;
      const top = screenHeight / 2 - popupHeight / 2;

      // 팝업 창의 옵션 설정
      const popupOptions = `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`;

      window.open(`${process.env.VUE_APP_INSA_TREE}`, null, popupOptions);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base/variables.scss';

.org {
  @media (min-width: 900px) {
    position: relative;
  }
}

.org-button {
  width: $iconButtonSize;
  height: $iconButtonSize;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  svg {
    width: 24px;
    height: 24px;
    color: #999999;
  }
  &:hover {
    background-color: rgba(159, 166, 173, 0.2);
  }
}

.org.is-small {
  .org-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    background: none;
    position: relative;

    svg {
      width: 20px;
      height: 20px;
      color: rgb(88, 88, 88);
    }

    &:hover {
      background-color: rgba(159, 166, 173, 0.2);
    }
    &.new {
      &::after {
        position: absolute;
        content: '';
        width: 5px;
        height: 5px;
        right: 3px;
        top: 3px;
        border-radius: 100%;
        background-color: #2985db;
      }
    }
  }
}
</style>
